import PromoCampaignUpdateHandler from './PromoCampaignUpdateHandler'

export default PromoCampaignUpdateHandler
